The opaque cursor to the candidate process history item.

This can be used as a subsequent pagination argument.
